import { createSvgComponent } from "../../icon/createSvgComponent";
import Minus from "@core/__generated__/icon/figma/minus.svg";
export default createSvgComponent(Minus);